import React, { useMemo, useEffect, useRef } from "react";
import { connect } from "dvajs";
import styles from "./index.module.less";
import ShareHotsCard from "./ShareHotsCard";
import BannerCard from "@/baseComponents/BannerCard";
import ShareQACard from "./ShareQACard";
import ShareGuideCard from "./ShareGuideCard";
import ChatContext from "@/components/chat/context";
import { sleep } from "@/utils/chat/message";

function AiGreeting(props: any) {
  const { message } = props;
  const { lastMessage } = React.useContext(ChatContext);
  const wrapRef = useRef<HTMLDivElement>(null);

  const dataList = useMemo(() => {
    if (!message?.data?.length) {
      return null;
    }
    return message?.data.map((item: any) => {
      if (item.nativeId === "share_greet_rec") {
        return (
          <div className={styles["item-node"]}>
            <ShareHotsCard message={item} />
          </div>
        );
      } else if (item.nativeId === "share_greet_carousel") {
        return (
          <div className={styles["item-node"]}>
            <BannerCard message={item} />
          </div>
        );
      } else if (item.nativeId === "share_recommend_qa") {
        // 您可以这样问
        return (
          <div className={styles["item-node"]}>
            <ShareQACard message={item} />
          </div>
        );
      } else if (item.nativeId === "share_guide_card") {
        // 欢迎卡片
        return (
          <div className={styles["item-node"]}>
            <ShareGuideCard message={item} />
          </div>
        );
      } else {
        return null;
      }
    });
  }, [message?.data]);

  return (
    <div className={styles["ai-greeting-wrap"]} ref={wrapRef}>
      {message?.content ? <div className={styles["prefix"]}>{message?.content}</div> : null}
      {dataList}
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    currentEmployee: chat.currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AiGreeting);
